<template>
  <p>
    <time :datetime="dateMin">{{ dateMin && getDisplayDates(dateMin, dateMax)[0] }}</time>
    <template v-if="!dateMin && getDisplayDates(dateMin, dateMax)[1]">
      <time :datetime="dateMax">{{ getDisplayDates(dateMin, dateMax)[1] }}</time>
    </template>
    <template v-if="dateMin && getDisplayDates(dateMin, dateMax)[1]">
      -
      <time :datetime="dateMax">{{ dateMin && getDisplayDates(dateMin, dateMax)[1] }}</time>
    </template>
  </p>
</template>

<script>
import { getDisplayDates } from '@/utils/formatter';

export default {
  name: 'Date',

  props: {
    dateMin: {
      type: String,
      default: () => ''
    },

    dateMax: {
      type: String,
      default: () => ''
    }
  },

  methods:{
    getDisplayDates
  }
};
</script>
